import {
  StatusMemberRegisterWaiting
} from 'app/api/event/model'
import { useGetActionRegisteredByMember } from 'app/react-query/hook/event'
import { useAppSelector } from 'app/redux/hooks'
import { useMemo } from 'react'


export const useActionRegisteredByStatusHook = ({
  status,
}: {
  status: StatusMemberRegisterWaiting
}) => {
  const user = useAppSelector(state => state?.user)?.profile
  const { data: response, isLoading } = useGetActionRegisteredByMember({
    member_id: user?.member?.id,
    status,
  })

  const data = useMemo(() => {
    return response?.data?.map((item, index) => {
      return {
        ...item,
        key: index + 1,
        index: index + 1,
      }
    })
  }, [response])

  return { data, isLoading }
}
